package com.nonopn.skydome.common.app.navigation

import androidx.compose.runtime.Composable
import com.nonopn.skydome.common.app.pages.consultation.ConsultationScreen
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterParameters
import kotlinx.serialization.Serializable

/**
 * Route for third-party consultation view — Strike Radar Phase 3.
 * Accessible via: /share/{token}
 *
 * Placeholder — activation conditioned on Kevin's backend.
 */
@Serializable
data class RouteConsultationParams(val token: String?) : RouteParameterTo

object RouterConsultation : RouterParameters<RouteConsultationParams>(
    RouteConsultationParams::class
) {
    const val ROUTE_PATTERN = "/share/{token}"
    const val ROUTE_NO_TOKEN = "/share/invalid"

    fun build(token: String) = "/share/$token"

    override fun routeFrom(parameters: RouteConsultationParams) =
        "/share/${parameters.token ?: "invalid"}"

    @Composable
    override fun Show(parameters: RouteConsultationParams) {
        RouteConsultationImpl(parameters).scene()
    }

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteConsultationParams

    override fun isMatching(route: String) =
        route.startsWith("/share/")

    override fun navigateFrom(path: String): RouteConsultationParams {
        val token = path.removePrefix("/share/").takeIf { it.isNotBlank() && it != "invalid" }
        return RouteConsultationParams(token)
    }

    override fun navigateTo(instance: RouteConsultationParams) = NavigateTo(
        route = instance,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )
}

class RouteConsultationImpl(
    params: RouteConsultationParams
) : Route<RouteConsultationParams>(
    route = RouterConsultation.ROUTE_PATTERN,
    params = params
) {
    @Composable
    override fun scene() {
        ConsultationScreen(shareToken = params.token)
    }
}
